import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6de7e46e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content has-background-contents shadow" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message" }, "この度はご協力いただき誠にありがとうございます。オンライン資料の自動収集申出を受け付けました。申出者のメールアドレスに受付内容を送信しています。本件についてお問い合わせの際は、受付番号をお知らせください。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message" }, "お申出いただいたオンライン資料が国立国会図書館で収集対象であるか確認して、申出者のメールアドレスに結果をご連絡します。収集対象である場合は、お知らせいただいたURLに当館がアクセスをして、収集プログラムを用いて収集（ファイルの複製）をいたします。当館での作業が終了した後に、国立国会図書館の施設内（東京本館、関西館、国際子ども図書館）で閲覧できるようになります。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message" }, "また、お申出いただいたオンライン資料のすべてが収集の対象となるものではありませんので予めご了承ください。", -1))
const _hoisted_7 = { class: "area-button" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 続けて申出をする ")
const _hoisted_9 = { class: "area-toButton" }
const _hoisted_10 = {
  href: "https://www.ndl.go.jp/jp/collect/online/index.html",
  class: "button-about"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" オンライン資料の納入について ")
const _hoisted_12 = { class: "area-toButton" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 国立国会図書館デジタルコレクション ホームページ ")
const _hoisted_14 = { class: "area-toButton" }
const _hoisted_15 = {
  href: "https://www.ndl.go.jp/",
  class: "button-toHP"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 国立国会図書館 ホームページ ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, "【受付番号:" + _toDisplayString(_ctx.receiptNumber) + "】", 1),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_AppButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('agreement'))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('agreement')), ["prevent"]), ["space","enter"])),
          styled: 'is-accent',
          buttonId: 'button-toAgreement'
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", _hoisted_10, [
          _createVNode(_component_DssIcon, { icon: 'arrow-right' }),
          _hoisted_11
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "button-toTop"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DssIcon, { icon: 'arrow-right' }),
            _hoisted_13
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("a", _hoisted_15, [
          _createVNode(_component_DssIcon, { icon: 'arrow-right' }),
          _hoisted_16
        ])
      ])
    ])
  ]))
}